/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Styled components for table column
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.1.0
 */
import styled from 'styled-components';

import { EColorStatus } from '../../../../../modules/app/appConstants';
import { colors, fonts } from '../../../../../theme';
import { TextContainerStyled } from '../../../../common/TextBlock/styled/TextBlockStyled';

export const TableTextContainerStyled = styled(TextContainerStyled)`
    ${(props) => (
            props.defaultColor
            ? `color: ${props.defaultColor};`
            : ''
    )}
`;

interface ITableTextStyled {
    colorState?: EColorStatus.SUCCESS | EColorStatus.ERROR;
}

export const TableTextStyled = styled.span<ITableTextStyled>`
    ${fonts.textMain};
    ${props => props.colorState ? `color: ${props.colorState === EColorStatus.SUCCESS ?
    colors.tableCellTextColorSuccess : colors.tableCellTextColorDanger}` : null}
`;

export const TableDateStyled = styled.span`
    ${fonts.textSmall};
    color: ${colors.tableCellTextColorSecondary};
`;

export const TableTextDefaultValueStyled = styled.span`
    ${fonts.textMain};
    color: ${colors.tableCellTextColorSecondary};
`;

interface ITableTextTooltipStyled {
    colorState?: EColorStatus;
}

export const TableTextTooltipStyled = styled.span.attrs({
    className: 'table__tooltip-text',
})<ITableTextTooltipStyled>`
    ${props => props.colorState ? `color: ${props.colorState === EColorStatus.SUCCESS ?
    colors.tableCellTextColorSuccess : props.colorState === EColorStatus.ERROR ?
        colors.tableCellTextColorDanger : colors.tableCellTextColorWarning}` : null}
`;

export const TableTextLinkStyled = styled.span.attrs({
    className: 'table__link',
})`
    ${fonts.textMain};
    border-bottom-color: ${colors.linkDefaultColorHover};
    border-bottom-width: 1px;
    ${fonts.textLink};
    text-decoration: none;
    cursor: pointer;
    &:hover,
    &:focus {
        border-bottom-style: solid;
    }
    & a {
        ${fonts.textLink};
        text-decoration: none;
    }
`;

export const TableConflictStyled = styled.span`
    ${fonts.textSmall};
    color: ${colors.tableCellTextColorSecondary};
`;

export const TableRemoveRowButtonStyled = styled.div`
    margin: 0 auto;
    height: 40px;
    width: 40px;
    cursor: pointer;
`
